import { render, staticRenderFns } from "./CrudDetalheSelect.vue?vue&type=template&id=e3b3647a"
import script from "./CrudDetalheSelect.vue?vue&type=script&lang=ts"
export * from "./CrudDetalheSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports